<template>
  <v-app>
     
    
    <v-main>

      <Navbar v-if="$route.path!='/cart' && $route.path!='/dashboard'  && $route.path!='/terminalpos' && $route.path!='/terminalpos/devices'" />

      <!-- <Navbar v-if="$route.path!='/cart' && $route.path!='/dashboard' && $route.path!='/admin/login'" /> -->

      <router-view/>
    </v-main>
  </v-app>
</template>

<script>
import Navbar from './components/NavBar.vue'
export default {
  name: 'App',
  components:{
    Navbar
  },

  data: () => ({
    dialog:false,
    totalprice:0,
    auth:localStorage.getItem("admin")
  }),
  methods:{
    checkout(){
      this.dialog=!this.dialog
      this.$store.commit("addTotalPrice",this.totalprice)
    }
  },
  mounted(){
    setInterval(() => {
      this.totalprice=0
      for(var i=0;i<this.$store.state.cart.length;i++){
        this.totalprice+=this.$store.state.cart[i].price
        
      }
    }, 1000);
  }
};
</script>
